<template>
  <div>
<!--    <div class="search-box">-->
<!--      <el-button @click="updateSourceList" type="primary">update voa</el-button>-->
<!--      <el-button @click="getVoaSourceList" type="primary">flash list</el-button>-->
<!--    </div>-->
    <div class="video-list">
<!--      Source List :-->
      <el-table v-loading="loading"
                :data="paginatedData"
                @row-click="handleRowClick"
                class="custom-table"
                :row-class-name="tableRowClassName">
        <el-table-column label="Title" prop="title"/>
        <el-table-column
            label="Create Time"
            prop="into_db_time"
            :formatter="formatDate"
            min-width="30%"/>
      </el-table>
      <div class="pagination-container">
        <el-pagination
            background
            layout="prev, pager, next"
            :total="voaList.length"
            @current-change="handleCurrentChange">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import {get} from '../api'

export default {
  name: 'VoaLearnEnglish',
  data() {
    return {
      loading: true,
      voaList: [],
      currentPage: 1,
      pageSize: 10, // 每页显示的条目数
    };
  },
  computed: {
    paginatedData() {
      const start = (this.currentPage - 1) * this.pageSize;
      const end = this.currentPage * this.pageSize;
      return this.voaList.slice(start, end);
    }
  },
  created() {
    this.getVoaSourceList()
  },
  methods: {
    // 添加行类名方法
    tableRowClassName({ rowIndex }) {
      return rowIndex % 2 === 0 ? 'even-row' : 'odd-row';
    },
    handleRowClick(row) {
      window.open('/voa/' + row.id, '_blank')
    },
    formatDate(row, column, cellValue) {
      var dt = new Date(cellValue);
      let year = dt.getFullYear();
      let month = (dt.getMonth() + 1).toString().padStart(2, '0');
      let date = dt.getDate().toString().padStart(2, '0');
      return `${year}-${month}-${date}`;
    },
    getVoaSourceList() {
      this.loading = true,
          get('/voa/list').then(res => {
            this.loading = false
            this.voaList = res.data
          })
    },
    updateSourceList() {
      get('/voa/update').then(() => {
        this.$message.success('开始更新VOA资源');
      })
    },
    handleCurrentChange(page) {
      this.currentPage = page;
    }
  },
};
</script>

<style>
.search-box {
  margin-top: 3%;
  margin-left: 1%;
}

.horizontal-form .el-form-item {
  display: inline-block;
  width: 30%;
}

.pagination-container {
  display: flex;
  justify-content: center;
  margin-top: 20px;
}

/* 表格样式 */
.custom-table {
  width: 60%;
  margin: 0 auto;
}

.custom-table .el-table__row {
  border-radius: 10px;
  margin-bottom: 10px;
  overflow: hidden;
}

.custom-table td {
  border: none;
  border-bottom: 1px solid #f0f0f0;
}

.custom-table .el-table__body tr {
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  margin-bottom: 10px;
  border-radius: 10px;
}

.custom-table .el-table__body {
  border-collapse: separate;
  border-spacing: 0 10px;
}

/* 交替行背景色 */
.custom-table .el-table__body tr.even-row {
  background-color: #ffffff;
}

.custom-table .el-table__body tr.odd-row {
  background-color: #f5f9ff; /* 浅蓝色 */
}

.custom-table .el-table__body tr:hover > td {
  background-color: transparent !important; /* 保持悬停效果 */
}

/* 调整 Title 列的标题和内容左边距 */
.custom-table .el-table__header .el-table__cell:first-child,
.custom-table .el-table__body .el-table__cell:first-child {
  padding-left: 20%;
}
</style>
